import script from "./Dialog2.vue?vue&type=script&setup=true&lang=js"
export * from "./Dialog2.vue?vue&type=script&setup=true&lang=js"

import "./Dialog2.vue?vue&type=style&index=0&id=f28cfbc4&lang=css"

const __exports__ = script;

export default __exports__